export default __webpack_public_path__ + "static/media/homepage-player.fc4d913d.jpg";